import { createContext, useContext, useState } from "react";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    const [sessionID, setSessionID] = useState(localStorage.getItem("sessionID"));


    const _login = (id) => {
        localStorage.setItem("sessionID", id);
        setSessionID(id);
    };

    const _logout = () => {
        localStorage.removeItem("sessionID");
        setSessionID(null);
    };

    const _setUser = (user) => {
        localStorage.setItem("user", JSON.stringify(user));
    };

    const _deleteUser = (user) => {
        localStorage.removeItem("user");
    };

    const _getUser = () => {
        const user = localStorage.getItem("user");
        return JSON.parse(user);
    };

    const isAuthenticated = !!sessionID;

    return (
        <AuthContext.Provider value={{ isAuthenticated, _login, _logout, _setUser, _deleteUser, _getUser }}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => useContext(AuthContext);
